export function getApiErrorMessage(
  error,
  fallback = "Something went wrong.",
) {
  const data = error?.response?.data;

  if (typeof data?.message === "string" && data.message.trim()) {
    return data.message;
  }

  if (data?.errors && typeof data.errors === "object") {
    const firstMessage = Object.values(data.errors)
      .flat()
      .find(Boolean);

    if (firstMessage) {
      return String(firstMessage);
    }
  }

  if (error?.request) {
    return "Unable to reach the server. Check the API address and network connection.";
  }

  return error?.message || fallback;
}
